/*
 * Copyright (C) Motorola Solutions, INC.
 * All Rights Reserved.
 */
// @ts-nocheck
import { AppSpecificConfig, HeaderConfigService } from '@msi/commandcentral-common-header';
import { Injectable } from '@angular/core';
@Injectable({
    providedIn: 'root'
})
export class CustomHeaderConfigService extends HeaderConfigService {
    constructor() {
        super(window, undefined);
    }

    private override initConfigObservable(): void {
        // defer initialization from super HeaderConfigService constructor
    }

    public override setAppSpecificConfig(config: AppSpecificConfig) {
        // defer initialization from super HeaderConfigService constructor
    }

    public customInitializationTrigger(config: AppSpecificConfig) {
        super.initConfigObservable();
        super.setAppSpecificConfig(config);
    }
}
